import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import {
  Container,
  HeaderBlock,
  Title,
  Subtitle,
  TableScroll,
  TableFrame,
  TableHeader,
  HeaderCell,
  HeaderButton,
  HeaderLabel,
  SortIconWrapper,
  TableBody,
  BodyRow,
  BodyCell,
  EmptyRow
} from './styles'

const getRowKey = (row, rowKey, index) => {
  if (typeof rowKey === 'function') return rowKey(row, index)
  if (typeof rowKey === 'string' && row && row[rowKey] !== undefined) return row[rowKey]
  return index
}

export function SortableTable ({
  columns = [],
  rows = [],
  title = '',
  subtitle = '',
  rowKey = 'id',
  getRowBackground,
  sortBy = '',
  sortDirection = 'asc',
  onSortChange,
  emptyMessage = 'No se encontraron resultados',
  minWidth = '1120px'
}) {
  const gridTemplateColumns = columns.map(column => column.width || '1fr').join(' ')

  const handleSortClick = (column) => {
    if (!column.sortable || typeof onSortChange !== 'function') {
      return
    }
    const nextDirection = sortBy === column.key && sortDirection === 'asc' ? 'desc' : 'asc'
    onSortChange({ key: column.key, direction: nextDirection })
  }

  const renderSortIcon = (column) => {
    if (!column.sortable) return null

    if (sortBy !== column.key) {
      return <ArrowUpDown size={18} />
    }

    return sortDirection === 'asc' ? <ArrowUp size={18} /> : <ArrowDown size={18} />
  }

  return (
    <Container>
      {(title || subtitle) && (
        <HeaderBlock>
          {title && <Title>{title}</Title>}
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </HeaderBlock>
      )}

      <TableScroll>
        <TableFrame minWidth={minWidth}>
          <TableHeader gridTemplateColumns={gridTemplateColumns}>
            {columns.map(column => (
              <HeaderCell key={column.key} align={column.align}>
                {column.sortable
                  ? (
                    <HeaderButton
                      type='button'
                      align={column.align}
                      onClick={() => handleSortClick(column)}
                    >
                      <HeaderLabel>{column.label}</HeaderLabel>
                      <SortIconWrapper>{renderSortIcon(column)}</SortIconWrapper>
                    </HeaderButton>
                    )
                  : (
                    <HeaderLabel>{column.label}</HeaderLabel>
                    )}
              </HeaderCell>
            ))}
          </TableHeader>

          <TableBody>
            {rows.length === 0 && (
              <EmptyRow>{emptyMessage}</EmptyRow>
            )}

            {rows.map((row, index) => {
              const rowId = getRowKey(row, rowKey, index)
              const rowBackground = typeof getRowBackground === 'function'
                ? getRowBackground(row, index)
                : undefined

              return (
                <BodyRow key={rowId} gridTemplateColumns={gridTemplateColumns} rowBackground={rowBackground}>
                  {columns.map(column => (
                    <BodyCell key={`${rowId}-${column.key}`} align={column.align}>
                      {column.render ? column.render(row) : row[column.key]}
                    </BodyCell>
                  ))}
                </BodyRow>
              )
            })}
          </TableBody>
        </TableFrame>
      </TableScroll>
    </Container>
  )
}

export default SortableTable
